import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserApiService } from './user-api.service';

@Injectable()
export class UserResolver  {
  constructor(private userApiService: UserApiService) {}

  public resolve(): Observable<any> | Promise<any> | any {
    return this.userApiService.getUser();
  }
}
